// For full API documentation, including code examples, visit https://wix.to/94BuAAs

let fullText;
let shortText;
let startdate;
let enddate;

$w.onReady(function () {

	$w("#repeater2").onItemReady(($item, itemData, index) => {
		fullText = itemData.full_description
		shortText = fullText.replace(/^([\s\S]{115}[^\s]*)[\s\S]*.*/, "$1") + " ...";
		$item('#text30').text = shortText;
	});

	$w("#repeater3").onItemReady(($item, itemData, index) => {
		//check if start date and end date are the same
		startdate = itemData.startDate
		enddate = itemData.endDate
		if (startdate === enddate) {
			$item("#text80").collapse();
			$item("#text97").collapse();
		}
	});

})